import { Navigate } from 'react-router-dom';
import { LogoutIcon } from '../../assets/icons';
import { useAuthContext, useLogout } from '../../hooks';
import './Settings.scss';

const Settings = () => {
  const { logout } = useLogout();
  const { user } = useAuthContext();

  if (!user) {
    return <Navigate to="/auth" />;
  }

  return (
    <div className="settings">
      <h2 className="title">Settings</h2>
      <button className="logout-btn" onClick={logout}>
        <LogoutIcon />
        <span>Logout</span>
      </button>
    </div>
  );
};

export default Settings;
